"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = useUniqueId;

var _react = require("react");

var _mathRandom = _interopRequireDefault(require("math-random"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* eslint no-magic-numbers: ["error", { "ignore": [2, 5, 36] }] */
function useUniqueId(prefix) {
  var id = (0, _react.useMemo)(function () {
    return (0, _mathRandom.default)().toString(36).substr(2, 5);
  }, []);
  prefix = prefix ? "".concat(prefix, "--") : '';
  return "".concat(prefix).concat(id);
}
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJuYW1lcyI6WyJ1c2VVbmlxdWVJZCIsInByZWZpeCIsImlkIiwidXNlTWVtbyIsInJhbmRvbSIsInRvU3RyaW5nIiwic3Vic3RyIl0sInNvdXJjZVJvb3QiOiJjb21wb25lbnQ6Ly8vIiwic291cmNlcyI6WyIuLi8uLi8uLi9zcmMvaG9va3MvaW50ZXJuYWwvdXNlVW5pcXVlSWQudHMiXSwic291cmNlc0NvbnRlbnQiOlsiLyogZXNsaW50IG5vLW1hZ2ljLW51bWJlcnM6IFtcImVycm9yXCIsIHsgXCJpZ25vcmVcIjogWzIsIDUsIDM2XSB9XSAqL1xuXG5pbXBvcnQgeyB1c2VNZW1vIH0gZnJvbSAncmVhY3QnO1xuaW1wb3J0IHJhbmRvbSBmcm9tICdtYXRoLXJhbmRvbSc7XG5cbmV4cG9ydCBkZWZhdWx0IGZ1bmN0aW9uIHVzZVVuaXF1ZUlkKHByZWZpeD86IHN0cmluZyk6IHN0cmluZyB7XG4gIGNvbnN0IGlkID0gdXNlTWVtbygoKSA9PiByYW5kb20oKS50b1N0cmluZygzNikuc3Vic3RyKDIsIDUpLCBbXSk7XG5cbiAgcHJlZml4ID0gcHJlZml4ID8gYCR7cHJlZml4fS0tYCA6ICcnO1xuXG4gIHJldHVybiBgJHtwcmVmaXh9JHtpZH1gO1xufVxuIl0sIm1hcHBpbmdzIjoiOzs7Ozs7O0FBRUE7O0FBQ0E7Ozs7QUFIQTtBQUtlLFNBQVNBLFdBQVQsQ0FBcUJDLE1BQXJCLEVBQThDO0VBQzNELElBQU1DLEVBQUUsR0FBRyxJQUFBQyxjQUFBLEVBQVE7SUFBQSxPQUFNLElBQUFDLG1CQUFBLElBQVNDLFFBQVQsQ0FBa0IsRUFBbEIsRUFBc0JDLE1BQXRCLENBQTZCLENBQTdCLEVBQWdDLENBQWhDLENBQU47RUFBQSxDQUFSLEVBQWtELEVBQWxELENBQVg7RUFFQUwsTUFBTSxHQUFHQSxNQUFNLGFBQU1BLE1BQU4sVUFBbUIsRUFBbEM7RUFFQSxpQkFBVUEsTUFBVixTQUFtQkMsRUFBbkI7QUFDRCJ9